import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var UpdateVehicleCCRes;
export const UpdateVehicleCCTodo = createAsyncThunk('UpdateVehicleCC', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Put",
            url: process.env.REACT_APP_API_URL +  `vehicle_cc/${data.id}`,
            data: {
                "vehicle_cc_name": data?.values?.cc,
                "vehicle_cc_status":data?.values?.status,
                "user_id": localStorage.getItem('user_id')
            },
            headers: { "Content-Type": "application/json" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return UpdateVehicleCCRes = res.data
        
    } catch (error) {
        return UpdateVehicleCCRes = error.response.data
    }
})
